/* eslint-disable no-console */
import { toast } from "react-hot-toast";
import { client, log, supabase } from ".";
import { capturarSnapshotDesdeContrato } from "./comisionSnapshot";

/**
 * Convierte número a ID alfabético de 3 letras (AAA=0, AAB=1, ..., ZZZ=17575)
 */
function numberToDisplayId(n) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const c1 = Math.floor(n / (26 * 26)) % 26;
  const c2 = Math.floor(n / 26) % 26;
  const c3 = n % 26;
  return chars[c1] + chars[c2] + chars[c3];
}

function displayIdToNumber(str) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  return chars.indexOf(str[0]) * 26 * 26 + chars.indexOf(str[1]) * 26 + chars.indexOf(str[2]);
}

async function getNextDisplayId() {
  const { data } = await client
    .from("sales_contratos")
    .select("display_id")
    .not("display_id", "is", null)
    .order("display_id", { ascending: false })
    .limit(1);

  if (!data || data.length === 0 || !data[0].display_id) {
    return "AAA";
  }

  const current = displayIdToNumber(data[0].display_id);
  return numberToDisplayId(current + 1);
}

export const saveContrato = async (contrato) => {
  try {
    const displayId = await getNextDisplayId();
    // insertReturning: trae la fila creada (con id + meses) de forma atómica
    const data = await supabase.insertReturning("sales_contratos", { ...contrato, display_id: displayId });

    if (!data || data.length === 0) throw new Error("Empty response");

    // Snapshot de comisión: N fotos (una por mes). ADITIVO — si falla, el contrato se crea igual
    try {
      await capturarSnapshotDesdeContrato(data[0], "creacion");
    } catch (snapErr) {
      log.error("saveContrato/snapshot", snapErr);
    }

    return data;
  } catch (error) {
    console.error("saveContrato error:", error);
    log.error("saveContrato", error);
    toast.error("Error al guardar el contrato");
    throw error;
  }
};
